<template>
    <section class="inner-content">
        <b-message v-if="error" type="is-danger">Something went wrong, please refresh the page</b-message>

        <search-form v-if="searchable" @searching="searching"/>

        <b-table
            :data="items"
            :total="total"
            :current-page="currentPage"
            :per-page="perPage"
            :loading="loading"
            class="product-table"
            paginated backend-pagination striped bordered
            :checkable="checkable"
            :checked-rows.sync="checkedRows"
            @page-change="changePage">
            <b-table-column
                v-for="column in columns"
                :key="column.field"
                :id="column.field"
                :label="column.label"
                :centered="column.centered"
                v-slot="props"
                :width="column.width">
                <table-actions
                    v-if="column.field === 'actions'"
                    :actions="column.actions"
                    :item="props.row"
                    :model="model"/>
                <div
                    v-else-if="column.field === 'stock_qty'"
                    class="item-stock"
                    @click="changeSku(props.row['id'], props.row['name'])">
                    <b-button rounded size="is-small">
                        {{ __('strings.product.table.stock_total') }}: {{ getHtmlValue(props.row[column.field]) }}
                    </b-button>
                </div>
                <img
                    v-else-if="column.field === 'thumbnail'"
                    :src="getHtmlValue(props.row['removed_on'], column.field) == null ? props.row[column.field] : '/images/removed.png'"
                    :alt="props.row['name']"/>
                <span
                    v-else
                    :class="{ 'removed-on' : getHtmlValue(props.row['removed_on'], column.field) !== null}"
                    v-html="getHtmlValue(props.row[column.field], column.field)"/>
            </b-table-column>
        </b-table>
        <b-modal v-model="isModalOpen" :width="640" scroll="keep" class="child-stock-modal" @close="!isModalOpen">
            <div v-if="!modalData.isLoading" class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">
                        {{ modalData.parentName }}
                    </p>
                </header>
                <section class="modal-card-body">
                    <div v-if="Object.keys(modalData.children).length > 0">
                        <div class="mb-3"
                             v-for="(children, retailer) in modalData.children" :key="retailer">
                            <p v-text="retailer" class="is-size-5 font-weight-bold mb-2"></p>
                            <b-table striped bordered :data="children" :columns="modalData.columns"></b-table>
                        </div>
                    </div>
                    <div class="mb-3" v-else>
                        <b-message title="Warning" type="is-warning" aria-close-label="Close message">
                            {{ __('strings.warnings.no_stock') }}
                        </b-message>
                    </div>
                </section>
                <footer class="modal-card-foot is-justify-content-flex-end">
                    <b-button @click="isModalOpen =  false">
                        {{ __('strings.close') }}
                    </b-button>
                </footer>
            </div>
        </b-modal>
    </section>
</template>

<script>
import TableSection from "../../table/TableSection";

export default {
    extends: TableSection,
    data() {
        return {
            isModalOpen: false,
            stockChildren: [],
            modalData: {
                isLoading: true,
                parentName: "",
                children: [],
                columns: []
            }
        };
    },
    created() {
        this.log(this.items);
        this.loading = this.tableShouldLoad
        axios.get('/columns/stock').then(response => {
            this.modalData.columns = response.data
        });
    },
    methods: {
        changePage(target) {
            this.$emit('handleProductSearch', {page: target});
        },
        changeSku(parentId, parentName) {
            axios.get('/stock/children', {params: {parentId: parentId}}).then(response => {
                this.modalData.children = Object.assign(response.data);
                this.isModalOpen = true;
                this.modalData.isLoading = false;
            });
            this.modalData.parentName = parentName;
        },
        getItems(query) {
            // DO NOT REMOVE -> TOBEFIXED
        },
    }
}
</script>
